import Storage from "../../helpers/Storage"
import { Usuario } from "../../types";

export const TipoApp = {
  PROFESSOR: 'PROFESSOR',
  GESTAO: 'GESTAO'
} as const;

export function useAuth() {
  const storageData = Storage.getUserData();
  const user = (storageData?.usuario ?? {}) as Usuario;

  const tipoApp = user.professor?.id ? TipoApp.PROFESSOR : TipoApp.GESTAO;

  return {
    user,
    professor: user.professor,
    tipoApp
  }
}
